<template>
  <b-modal id="logbook-modal" title="Logbook" size="lg" ok-only>
    <template v-if="data">
      <div class="mb-4">
        <h5>Route: {{ data.route }}</h5>
        <div class="logbook-details mb-3">
          <div class="row">
            <div class="col-md-6">
              <strong>Time:</strong> {{ data.time }}
            </div>
            <div class="col-md-6">
              <strong>Destination:</strong>
            </div>
            <div class="col-md-6">
              <strong>ETA:</strong>
            </div>
            <div class="col-md-6">
              <strong>Position:</strong> {{ data.position }}
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-6"></div>
            <div class="col-md-2">
              <strong>SOG:</strong> {{ data.spd }}
            </div>
            <div class="col-md-2">
              <strong>COG:</strong> {{ data.cog }}
            </div>
            <div class="col-md-2">
              <strong>HDG:</strong> {{ data.hdg }}
            </div>
          </div>
        </div>

        <b-alert show variant="danger" dismissible>
          New alerts are available!
        </b-alert>
        <b-alert show variant="warning" dismissible>
          New logbook entries are available!
        </b-alert>

        <b-table size="sm"
                 :items="paginatedMessages"
                 :fields="fields"
                 :tbody-tr-class="rowClass"
                 small
                 striped></b-table>
        <b-pagination
            v-model="currentPage"
            :total-rows="data.messages.length"
            :per-page="perPage"
            align="center"
            class="mt-3"
        ></b-pagination>
      </div>
    </template>
    <div class="text-center mt-3">
      <b-link @click="goToLogbook">View full logbook</b-link>
    </div>
  </b-modal>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      fields: [
        {key: 'time', label: 'Time'},
        {key: 'type', label: 'Type'},
        {key: 'position', label: 'Position'},
        {key: 'message', label: 'Message'}
      ],
      currentPage: 1,
      perPage: 5
    }
  },
  computed: {
    // Пагинация для отображения только части сообщений
    paginatedMessages() {
      if (!this.data || !this.data.messages) return [];

      const messages = this.data.messages.slice().reverse();
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return messages.slice(start, end);
    }
  },
  methods: {
    // Стилизация строк таблицы
    rowClass(item) {
      return item.type === 'alert' ? 'table-danger' : '';
    },
    // Перевод на страницу журнала
    goToLogbook() {
      this.$bvModal.hide('logbook-modal');
      this.$router.push('/logbook');
    }
  }
}
</script>